/**
 * 图片模型 → SEO 落地页路径
 * 与 ImageModelSeo.vue 的 SLUG_MAP 对齐；聚合页会覆盖同系列多个 modelId。
 * 对不上的由 getImageModelPath 回退到 /models/:id
 */
var MODEL_ID_TO_SEO_SLUG = {
  'flux-pro-1-1-ultra': 'flux-1-ai-image-generator',
  'flux-schnell': 'flux-1-ai-image-generator',
  'flux-2': 'flux-2-ai-image-generator',
  'seedream-5': 'seedream-ai-image-generator',
  'seedream-4': 'seedream-ai-image-generator',
  'qwen-image-2-0-pro': 'qwen-image-2-0-pro-ai-image-generator',
  'sd-3-5': 'stable-diffusion-ai-image-generator',
  'stable-diffusion-3-5': 'stable-diffusion-ai-image-generator',
  'z-image-turbo': 'z-image-turbo-ai-image-generator',
  'midjourney': 'midjourney-ai-image-generator',
  'gpt-image-1-5': 'gpt-image-ai-image-generator',
  'gpt-image-1': 'gpt-image-ai-image-generator'
}

function getImageModelSeoSlug(modelId, routeId) {
  return MODEL_ID_TO_SEO_SLUG[modelId] || MODEL_ID_TO_SEO_SLUG[routeId] || ''
}

/**
 * @param {string|{id:string,routeId?:string}} model
 * @returns {string} 以 / 开头的站内路径（不含语言前缀）
 */
function getImageModelPath(model) {
  var id = ''
  var routeId = ''
  if (model && typeof model === 'object') {
    id = model.id || ''
    routeId = model.routeId || ''
  } else {
    id = String(model || '')
  }
  var slug = getImageModelSeoSlug(id, routeId)
  if (slug) return '/image-models/' + slug
  return '/models/' + (routeId || id)
}

module.exports = {
  MODEL_ID_TO_SEO_SLUG: MODEL_ID_TO_SEO_SLUG,
  getImageModelSeoSlug: getImageModelSeoSlug,
  getImageModelPath: getImageModelPath
}
